export default __webpack_public_path__ + "static/media/livenyte-logo-with-background.f386e1e9.png";